export default {
	id: "macbook-air",
	title: "Macbook Air",
	company: "Apple",
	styles: [
		{
			title: "normal",
			pos: ["6.8%", "13.2%", "13%", "13.2%"],
			colors: [
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				}
			]
		},
		{
			title: "flat",
			pos: ["6.8%", "13.2%", "13%", "13.2%"],
			colors: [
				{title: "Silver", hex: "#D5D2CF", img: require("./flat/silver.svg")}
			]
		}
	]
};
